export const routes = [
  {
    path: '',
    name: 'WidgetList',
    component: () => import('./pages/WidgetList.vue'),
    meta: {
      title: 'Виджеты',
      authorize: [],
    },
  },
];

export default routes;
